import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ShieldCheck, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError, LOGO_URL } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex topo-bg text-white flex-col justify-between p-12">
        <Link to="/" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="LBM" className="h-12 w-12 rounded-full object-contain bg-white ring-2 ring-secondary p-0.5" />
          <span className="font-heading font-extrabold text-lg">London Boy Movement</span>
        </Link>
        <div>
          <ShieldCheck className="w-12 h-12 text-secondary mb-4" />
          <h2 className="font-heading font-black text-4xl leading-tight">Command Center</h2>
          <p className="mt-4 text-emerald-50 max-w-sm">Secure, role-based access to member data, reward disbursement and statewide analytics.</p>
        </div>
        <div className="text-emerald-100 text-sm">Nasarawa State · 13 LGAs</div>
      </div>

      <div className="flex items-center justify-center p-6 bg-slate-50">
        <div className="w-full max-w-md">
          <Link to="/" className="text-sm text-muted-foreground inline-flex items-center gap-1 mb-8 hover:text-primary"><ArrowLeft className="w-4 h-4" /> Back to site</Link>
          <h1 className="font-heading font-black text-3xl">Admin Login</h1>
          <p className="text-muted-foreground mt-1 mb-8">Sign in to the control center.</p>
          <form onSubmit={submit} className="space-y-4">
            <div><Label className="font-semibold mb-1.5 block">Email</Label><Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@londonboymovement.ng" required /></div>
            <div><Label className="font-semibold mb-1.5 block">Password</Label><Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required /></div>
            <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full rounded-full bg-primary font-bold py-6 gap-2">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Sign In</Button>
          </form>
        </div>
      </div>
    </div>
  );
}
